import { Logger, getWindow } from '@sitecore-search/common';
import { getConfigProperty } from '../config.js';
const WINDOW = getWindow();
class Cache {
    constructor(name) {
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
        this.cache = {};
        if (!WINDOW.RFK_CACHE) {
            WINDOW.RFK_CACHE = {};
        }
        WINDOW.RFK_CACHE[name] = this.cache;
    }
    /**
     * Example String(this.hashKey(JSON.stringify(this.sortObjectKeys(obj))))
     * @param key
     * @protected
     */
    hashKey(key) {
        let hash = 0;
        let i;
        let chr;
        let len;
        for (i = 0, len = key.length; i < len; i++) {
            chr = key.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0;
        }
        return hash;
    }
    sortObjectKeys(obj) {
        // TODO: change this for god sake
        if (obj === null || obj === undefined) {
            return '';
        }
        if (typeof obj !== 'object') {
            // it is a primitive: number/string (in an array)
            return obj;
        }
        return Object.keys(obj)
            .sort()
            .reduce((acc, key) => {
            if (Array.isArray(obj[key])) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                acc[key] = obj[key].map((value) => this.sortObjectKeys(value));
            }
            else if (typeof obj[key] === 'object') {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                acc[key] = this.sortObjectKeys(obj[key]);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    createKey(obj) {
        const key = JSON.stringify(this.sortObjectKeys(obj));
        if (!getConfigProperty('debug')) {
            return String(this.hashKey(key));
        }
        else {
            Logger.debug('cache ::: createKey', obj);
        }
        return key;
    }
    has(key) {
        return key in this.cache;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    delete(key) {
        delete this.cache[key];
    }
    all() {
        return this.cache;
    }
    clear() {
        this.cache = {};
        window.RFK_CACHE[this.name] = this.cache;
    }
    getName() {
        return this.name;
    }
}
export default Cache;
